
export {
    ADDRESS_DETAILS_KEYS, DEFAULT_VALUE_FOR_HIDE_FROM_USER_TYPES, MIN_AGE,
    PLAYER_INFO_DIFFERENCE_MAP, INTERNAL_EMAIL, SUPPORTED_FIELD_TYPES, AREA_CODES
} from '@core/js/components/common/ChangeForm/constants';

export const FORM_FIELD_TYPE = Object.freeze({
    TEXT_LABEL: 'textLabel',
    BUTTON: 'button',
    SEPARATOR: 'separator',

    TEXT: 'text',
    CHECKBOX: 'checkbox',
    DROPDOWN: 'dropdown',
    RADIO_BUTTON: 'radioButton',
    DATE_PICKER: 'datePicker',

    ADDRESS_LOOKUP_SWISS: 'addressLookupSwiss',
    ADDRESS_LOOKUP: 'addressLookup',
    USER_NAME: 'userName',
    PASSWORD: 'password',
    COUNTRY: 'country',
    CURRENCY_CODE: 'currencyCode',
    CELLPHONE: 'cellphone',
    PHONE: 'phone',
    DEPOSIT_LIMITS: 'depositLimits',
    BET_LIMITS: 'betLimits',
    LOSS_LIMITS: 'lossLimits',
    DATE_OF_BIRTH: 'dateOfBirth',
    EMAIL: 'email',
    POLAND_ID: 'polandID',
    ROMANIAN_ID: 'romanianID',
    SPANISH_ID: 'spanishID',
    PORTUGAL_ID: 'portugalID',
    SOUTH_AFRICAN_ID: 'southAfricanID',
    IBAN: 'iban'
});

export const SUPPORTED_FORM_FIELD_TYPE = [
    FORM_FIELD_TYPE.TEXT,
    FORM_FIELD_TYPE.PASSWORD,
    FORM_FIELD_TYPE.CHECKBOX,
    FORM_FIELD_TYPE.RADIO_BUTTON,
    FORM_FIELD_TYPE.DROPDOWN,
    FORM_FIELD_TYPE.DATE_OF_BIRTH,
    FORM_FIELD_TYPE.DATE_PICKER,
    FORM_FIELD_TYPE.BUTTON,
    FORM_FIELD_TYPE.CELLPHONE
];
